import $http from "@/helpers/http";
import Logger from "@/helpers/logger";

class ReferralApi {
  generateCelloToken() {
    try {
      return $http.post("external/cello/generate-token", {});
    } catch (e) {
      Logger.error("`generateCelloToken` API error", e);
      return Promise.reject(e);
    }
  }

  getCelloRewardDetails() {
    try {
      return $http.get("external/cello/reward-details", {});
    } catch (e) {
      Logger.error("`getCelloRewardDetails` API error", e);
      return Promise.reject(e);
    }
  }
}

const referralApi = new ReferralApi();

export default referralApi;
